/* src/app/shared/modal/modal.component.scss */
.header {
  position: sticky;
  top: 0;
  z-index: 2;
  width: 100%;
}
.modal {
  overflow-y: auto;
}
.body {
  min-height: 100%;
}
/*# sourceMappingURL=modal.component.css.map */
